import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './utStyle.css';
import config from '../../config.json';
import UTLabel from './utLabel';

const apiUrl = config.apiUrl;

const UTDetails = () => {
    const [undertimeDetails, setUndertimeDetails] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        DateStart: '',
        DateEnd: '',
        Duration: '',
        Remarks: '',
        Status: '',
        CreatedBy: '',
        CreatedDate: '',
        ApprovedBy: '',
        ApprovedDate: '',
        UpdatedBy: '',
        UpdatedDate: '',
    });

    const { undertimeId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchUndertimeData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Undertime/${undertimeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch undertime data');
                    setSuccessMessage('');
                    return;
                }
                const data = await response.json();
                setUndertimeDetails({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                    CreatedBy: data.Details.CreatedBy,
                    CreatedDate: data.Details.CreatedDate,
                    ApprovedBy: data.Details.ApprovedBy,
                    ApprovedDate: data.Details.ApprovedDate,
                    UpdatedBy: data.Details.UpdatedBy,
                    UpdatedDate: data.Details.UpdatedDate,
                });
            } catch (error) {
                setErrorMessage('Error fetching undertime data');
                setSuccessMessage('');
            }
        };

        fetchUndertimeData();
    }, []);

    const {
        TransactionID,
        TransactionDate,
        Employee,
        DateStart,
        DateEnd,
        Duration,
        Remarks,
        Status,
        CreatedBy,
        CreatedDate,
        ApprovedBy,
        ApprovedDate,
        UpdatedBy,
        UpdatedDate,
    } = undertimeDetails;

    return (
        <div>
            {userAccess.hasView ? (
                <>
                    <h3>View Undertime</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <div className="row mt-4">
                        <UTLabel label="Transaction ID" value={TransactionID} />
                        <UTLabel label="Transaction Date" value={TransactionDate} />
                        <UTLabel label="Employee" value={Employee.Name} />
                        <UTLabel label="Date Start" value={DateStart} />
                        <UTLabel label="Date End" value={DateEnd} />
                        <UTLabel label="Duration" value={Duration} />
                        <UTLabel label="Remarks" value={Remarks} />
                        <UTLabel label="Status" value={Status} />
                        <UTLabel label="CreatedBy" value={CreatedBy} />
                        <UTLabel label="CreatedDate" value={CreatedDate} />
                        <UTLabel label="UpdatedBy" value={UpdatedBy} />
                        <UTLabel label="UpdatedDate" value={UpdatedDate} />
                        <UTLabel label="ApprovedBy" value={ApprovedBy} />
                        <UTLabel label="ApprovedDate" value={ApprovedDate} />

                        <div className="mb-2">
                            <Link to="/undertime-list" className="btn btn-secondary">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <Link
                                    to={`/undertime-update/${undertimeId}`}
                                    className={`btn btn-primary ms-2 ${Status === 'Approved' || Status === 'Rejected' ? 'disabled' : ''}`}
                                >
                                    Edit
                                </Link>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default UTDetails;
